import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { Waypoint } from 'react-waypoint';
import {
  getAllProducts,
  getSubCategory
} from '../../../store/actions/user/User';
import { connect } from 'react-redux';
import { Divider } from '@material-ui/core';
import SkeletonLoad from '../Preloader/SkeletonLoad';
import { getVendorDetails } from '../../../store/actions/shared/Shared';
import { Link } from 'react-router-dom';
import store from '../../../store/reducers/rootReducer';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box pt={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`
  };
}

function LinkTab(props) {
  return (
    <Tab
      component="a"
      onClick={(event) => {
        event.preventDefault();
      }}
      {...props}
    />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper
  }
}));

function NavTabs(props) {
  const classes = useStyles();
  const { auth } = props;
  const [value, setValue] = React.useState(0);
  const [thePosition, setThePosition] = React.useState(1);
  const [subCategory2, setSubCategory] = React.useState('all');

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const goto = (ele) => {
    let offsetTop = document.getElementById(ele).offsetTop;
    var scr = document.getElementById('scrollDiv');
    scr.scrollTo({
      top: offsetTop - 10,
      behavior: 'smooth'
    });
  };
  const onPressCategory = () => {
    window.scrollTo({ top: 401, behavior: 'smooth' });
  };
  useEffect(() => {
    var uid = props.match.params.uid;
    props.getVendorDetails(uid);
    props.getAllProducts('Liquor', props.match.params.uid);
    props.getSubCategory('Liquor', props.match.params.uid);

    document.addEventListener('scroll', () => {
      if (window.scrollY > 329) {
        setThePosition(true);
      } else {
        setThePosition(false);
      }
    });
    window.scrollTo(0, 0);
  }, []);

  const handle = (e, product, index) => {
    e.preventDefault();
    product = {
      ...product,
      mrp: product.mrp[index],
      price: product.price[index],
      description: product.description[index],
      image: product.image[index],
      stock: product.stock[index],
      index: index
    };

    if (localStorage.getItem('cart')) {
      var setcart = JSON.parse(localStorage.getItem('cart'));
      var container = setcart.filter(
        (item) => item.description === product.description
      );
      if (container.length === 0) {
        setcart[setcart.length] = { ...product, quantity: 1 };
        localStorage.setItem('cart', JSON.stringify(setcart));
        store.dispatch({ type: 'ADD_TO_CART', payload: { data: setcart } });
      }
    } else {
      var addtolocal = [{ ...product, quantity: 1 }];
      localStorage.setItem('cart', JSON.stringify(addtolocal));
      store.dispatch({ type: 'ADD_TO_CART', payload: { data: addtolocal } });
    }
  };

  var difference, closeHours;
  const { liquor_products, liquor_subcategory } = props.products;

  if (props.vendor.closetime) {
    if (props.vendor.closetime.includes('pm')) {
      var openHours, openMin;
      closeHours = parseInt(
        props.vendor.closetime.substring(0, props.vendor.closetime.indexOf(':'))
      );
      closeHours = closeHours === 12 ? closeHours : closeHours + 12;
      const closeMin = parseInt(
        props.vendor.closetime.substring(
          props.vendor.closetime.indexOf(':') + 1,
          props.vendor.closetime.indexOf(':') + 3
        )
      );
      // const openHours = (parseInt(props.vendor.opentime.substring(0,props.vendor.opentime.indexOf(':')))+12)*60
      // const openMin   = parseInt(props.vendor.opentime.substring(props.vendor.opentime.indexOf(':')+1,props.vendor.opentime.indexOf(':')+3))
      if (props.vendor.opentime.includes('am')) {
        openHours = parseInt(
          props.vendor.opentime.substring(0, props.vendor.opentime.indexOf(':'))
        );
        openHours = openHours === 12 ? 0 : openHours;
        closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
        openHours *= 60;
        openMin = parseInt(
          props.vendor.opentime.substring(
            props.vendor.opentime.indexOf(':') + 1,
            props.vendor.opentime.indexOf(':') + 3
          )
        );
      } else {
        openHours = parseInt(
          props.vendor.opentime.substring(0, props.vendor.opentime.indexOf(':'))
        );
        openHours = openHours === 12 ? openHours : openHours + 12;
        closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
        openHours *= 60;
        openMin = parseInt(
          props.vendor.opentime.substring(
            props.vendor.opentime.indexOf(':') + 1,
            props.vendor.opentime.indexOf(':') + 3
          )
        );
      }
      closeHours *= 60;
      const currentHours = new Date().getHours() * 60;
      const currentMinutes = new Date().getMinutes();

      const today = new Date().getDay().toString();
      if (props.vendor.days && props.vendor.days.indexOf(today) === -1) {
        difference = -1;
      }
      if (openHours + openMin === closeHours + closeMin) {
        difference = 1;
      } else if (
        currentHours + currentMinutes > openHours + openMin &&
        currentHours + currentMinutes < closeHours + closeMin
      ) {
        difference = 1;
      } else {
        difference = -1;
      }
    } // if time in A.M.
    else {
      closeHours = parseInt(
        props.vendor.closetime.substring(0, props.vendor.closetime.indexOf(':'))
      );
      closeHours = closeHours === 12 ? 0 : closeHours;
      const closeMin = parseInt(
        props.vendor.closetime.substring(
          props.vendor.closetime.indexOf(':') + 1,
          props.vendor.closetime.indexOf(':') + 3
        )
      );
      const currentHours = new Date().getHours() * 60;
      const currentMinutes = new Date().getMinutes();
      if (props.vendor.opentime.includes('am')) {
        openHours = parseInt(
          props.vendor.opentime.substring(0, props.vendor.opentime.indexOf(':'))
        );
        openHours = openHours === 12 ? 0 : openHours;
        closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
        openHours *= 60;
        openMin = parseInt(
          props.vendor.opentime.substring(
            props.vendor.opentime.indexOf(':') + 1,
            props.vendor.opentime.indexOf(':') + 3
          )
        );
      } else {
        openHours = parseInt(
          props.vendor.opentime.substring(0, props.vendor.opentime.indexOf(':'))
        );
        openHours = openHours === 12 ? openHours : openHours + 12;
        closeHours = openHours > closeHours ? closeHours + 24 : closeHours;
        openMin = parseInt(
          props.vendor.opentime.substring(
            props.vendor.opentime.indexOf(':') + 1,
            props.vendor.opentime.indexOf(':') + 3
          )
        );
      }

      closeHours *= 60;
      const today = new Date().getDay().toString();
      if (props.vendor.days && props.vendor.days.indexOf(today) === -1) {
        difference = -1;
      } else if (openHours + openMin === closeHours + closeMin) {
        difference = 1;
      } else if (
        currentHours + currentMinutes > openHours + openMin &&
        currentHours + currentMinutes < closeHours + closeMin
      ) {
        difference = 1;
      } else {
        difference = -1;
      }
    }
  }

  return (
    <>
      <div className={classes.root}>
        <div
          className=""
          style={{
            marginBottom: '0',
            paddingRight: '0',
            paddingLeft: '0',
            marginTop: '3.4em',
            background: 'white',
            marginRight: '0px',
            boxShadow: 'inset 0 0 10px #000000'
          }}
        >
          <div className="container-fluid">
            <div className="row">
              <div
                className="bgImage special-background"
                style={{
                  height: '400px',
                  backgroundImage: `url("https://images2.alphacoders.com/887/thumb-1920-887494.jpg")`,
                  boxShadow: 'inset 0 0 10px #000000',
                  backgroundSize: 'cover',
                  resize: 'both',
                  borderBottom: '1px solid #00000010',
                  paddingBottom: '1px',
                  marginBottom: 0
                }}
              >
                {!props.store_loader ? (
                  <>
                    <div className="container-fluid">
                      <div
                        className="row"
                        id="shiftRight"
                        style={{ marginTop: '32px' }}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            background: '#ffffff',
                            marginLeft: '-24px',
                            paddingRight: '1px',
                            paddingLeft: '15px',
                            paddingTop: '15px',
                            paddingBottom: '15px'
                          }}
                          className="col-12 col-sm-5 shadow-lg"
                        >
                          <div
                            className="col-5 col-sm-3"
                            style={{ textAlign: 'left' }}
                          >
                            <img
                              alt="store"
                              style={{ height: '140px', borderRadius: '3px' }}
                              className="shadow-lg"
                              src={props.vendor.image}
                            />
                          </div>
                          <div
                            className="col-7 col-sm-10 "
                            style={{ textAlign: 'initial', marginLeft: '-5px' }}
                          >
                            <div>
                              <h3
                                className="vendorname"
                                style={{
                                  fontWeight: 'bold',
                                  textTransform: 'capitalize'
                                }}
                              >
                                {props.vendor.name}
                              </h3>
                              <h6
                                style={{
                                  color: 'secondary',
                                  paddingTop: '5px',
                                  paddingBottom: '5px',
                                  fontWeight: '400',
                                  fontSize: '16px',
                                  lineHeight: '16px'
                                }}
                              >
                                <i
                                  className="fa fa-map-marker"
                                  style={{
                                    color: 'secondary',
                                    marginRight: '10px',
                                    fontWeight: '300',
                                    fontSize: '16px',
                                    lineHeight: '16px'
                                  }}
                                ></i>
                                {props.vendor.location}
                              </h6>
                              <h6
                                className="category-liquor"
                                style={{
                                  color: 'secondary',
                                  paddingTop: '5px',
                                  paddingBottom: '5px',
                                  fontWeight: '400',
                                  fontSize: '13px',
                                  paddingRight: '2px',
                                  lineHeight: '18px',
                                  display: 'flex'
                                }}
                              >
                                <i
                                  className="fa fa-tag"
                                  style={{
                                    color: 'secondary',
                                    marginRight: '7px',
                                    fontWeight: '300',
                                    fontSize: '13px',
                                    lineHeight: '16px'
                                  }}
                                ></i>{' '}
                                <div>
                                  <span> •Beer</span>
                                  <span> •Cider</span>
                                  <span> •White Wine</span>
                                  <span> •Red Wine</span>
                                  <span> •Champagne and Sparklings</span>
                                  <span> •Spirits</span>
                                  <span> •Mixed Drinks</span>
                                </div>
                              </h6>
                              <h5
                                style={{
                                  color: 'secondary',
                                  paddingTop: '5px',
                                  paddingBottom: '5px',
                                  fontWeight: '300',
                                  fontSize: '15px',
                                  lineHeight: '16px',
                                  display: 'flex'
                                }}
                              >
                                <i
                                  className="fa fa-clock-o"
                                  style={{
                                    color: 'secondary',
                                    marginRight: '6px',
                                    fontWeight: '300',
                                    fontSize: '15px',
                                    lineHeight: '16px'
                                  }}
                                ></i>{' '}
                                <b>
                                  {/* {this.props.vendor.opentime} to{this.props.vendor.closetime}*/}{' '}
                                  {(
                                    props.match.params.distance * 1.5 +
                                    15
                                  ).toFixed(2)}{' '}
                                  mins | {props.match.params.distance}Km |{' '}
                                  {difference > 0 ? (
                                    <b style={{ color: '#36BA92' }}>
                                      <i className="fa fa-check"></i> Open
                                    </b>
                                  ) : (
                                    <b style={{ color: '#ce1d27' }}>
                                      <i className="fa fa-times"></i> Closed
                                    </b>
                                  )}
                                </b>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <SkeletonLoad />
                )}
              </div>
            </div>
          </div>
        </div>
        <div
          className="container-fluid"
          style={
            thePosition === false
              ? { zIndex: '99' }
              : { position: 'sticky', zIndex: '99', top: '55px' }
          }
        >
          <div className="row">
            <AppBar position="sticky">
              <Tabs
                variant="scrollable"
                value={value}
                onChange={handleChange}
                aria-label="nav tabs example"
                className={classes.tabDecor}
                style={{ background: 'white' }}
              >
                <LinkTab
                  label="Beer"
                  onClick={() => {
                    onPressCategory();
                  }}
                  style={{
                    textDecoration: 'none',
                    color: 'black',
                    borderRight: '0.5px solid #00000040',
                    paddingLeft: '25px'
                  }}
                  {...a11yProps(0)}
                />
                <LinkTab
                  label="Cider"
                  onClick={() => {
                    onPressCategory();
                  }}
                  style={{
                    textDecoration: 'none',
                    color: 'black',
                    borderRight: '0.5px solid #00000040'
                  }}
                  {...a11yProps(1)}
                />
                <LinkTab
                  label="White Wine"
                  onClick={() => {
                    onPressCategory();
                  }}
                  style={{
                    textDecoration: 'none',
                    color: 'black',
                    borderRight: '0.5px solid #00000040'
                  }}
                  {...a11yProps(2)}
                />
                <LinkTab
                  label="Red Wine"
                  onClick={() => {
                    onPressCategory();
                  }}
                  style={{
                    textDecoration: 'none',
                    color: 'black',
                    borderRight: '0.5px solid #00000040'
                  }}
                  {...a11yProps(3)}
                />
                <LinkTab
                  label="Champagne and Sparklings"
                  onClick={() => {
                    onPressCategory();
                  }}
                  style={{
                    textDecoration: 'none',
                    color: 'black',
                    borderRight: '0.5px solid #00000040'
                  }}
                  {...a11yProps(4)}
                />
                <LinkTab
                  label="Spirits"
                  onClick={() => {
                    onPressCategory();
                  }}
                  style={{
                    textDecoration: 'none',
                    color: 'black',
                    borderRight: '0.5px solid #00000040'
                  }}
                  {...a11yProps(5)}
                />
                <LinkTab
                  label="Mixed Drinks"
                  onClick={() => {
                    onPressCategory();
                  }}
                  style={{
                    textDecoration: 'none',
                    color: 'black',
                    borderRight: '0.5px solid #00000040'
                  }}
                  {...a11yProps(6)}
                />
              </Tabs>
            </AppBar>
          </div>
        </div>
        <TabPanel value={value} index={0}>
          <div className="container-fluid">
            <div className="row">
              <div
                className="col-lg-2 order-2 order-lg-1"
                style={{ marginTop: '-1em', paddingTop: '1em' }}
              >
                <div className="filter-widget">
                  <h5
                    style={{
                      textAlign: 'start',
                      color: '#000',
                      fontWeight: '400',
                      marginLeft: '12px'
                    }}
                  >
                    Sort by
                  </h5>
                  <div
                    className="col-12"
                    style={{
                      paddingTop: '0px',
                      marginTop: '-15px',
                      textAlign: 'start',
                      color: '#000'
                    }}
                  >
                    <i
                      className="fa fa-window-minimize"
                      id="line"
                      aria-hidden="true"
                    ></i>
                    <i className="fa fa-window-minimize" aria-hidden="true"></i>
                  </div>
                  <ul className="category-menu">
                    {liquor_subcategory.map((subCategory) =>
                      subCategory.includes('Beer') ? (
                        <li key={subCategory}>
                          <Link
                            style={
                              subCategory2 === subCategory
                                ? { background: '#36B89250' }
                                : { background: '#96B89210' }
                            }
                            onClick={() => {
                              goto(subCategory);
                              onPressCategory();
                              setSubCategory(subCategory);
                            }}
                            className={
                              subCategory2 === subCategory
                                ? 'category-menu-active'
                                : 'normal'
                            }
                          >
                            <h5
                              style={{
                                textAlign: 'initial',
                                color: '#000',
                                fontWeight: '400',
                                textTransform: 'capitalize'
                              }}
                            >
                              {subCategory.slice(0, subCategory.indexOf('('))}
                            </h5>
                          </Link>
                        </li>
                      ) : (
                        ''
                      )
                    )}
                  </ul>
                </div>
              </div>
              <div
                className="col-lg-10  order-1 order-lg-2 mb-5 mb-lg-0 "
                id="scrollDiv"
                style={{
                  borderLeft: '1px solid lightgrey',
                  paddingLeft: '0',
                  backgroundColor: '#f8f8f8',
                  height: '70vh',
                  overflow: 'scroll',
                  marginTop: '-1em',
                  paddingTop: '1em'
                }}
              >
                <div className="row ml-0">
                  <div className="col-12" style={{ textAlign: 'left' }}>
                    <h5
                      style={{
                        color: '#000',
                        paddingBottom: '0px',
                        marginBottom: '0px',
                        fontWeight: '400'
                      }}
                    >
                      Products (
                      {
                        liquor_products
                          .filter(
                            (product) => product.super_category === 'Beer'
                          )
                          .map((product) => product).length
                      }
                      )
                    </h5>
                  </div>
                  <div
                    className="col-12"
                    style={{
                      paddingTop: '0px',
                      marginTop: '-12px',
                      textAlign: 'start',
                      color: '#000'
                    }}
                  >
                    <i
                      className="fa fa-window-minimize"
                      id="line"
                      aria-hidden="true"
                    ></i>
                    <i className="fa fa-window-minimize" aria-hidden="true"></i>
                  </div>
                </div>
                <br />
                <div className="row"></div>
                {liquor_subcategory.map((subName) =>
                  subName.includes('Beer') ? (
                    <div className="container-fluid" id={subName}>
                      <div className="row">
                        <div
                          className="col-12"
                          style={{ textAlign: 'initial' }}
                        >
                          <h5 style={{ fontWeight: '400', color: '#000' }}>
                            {subName.slice(0, subName.indexOf('('))}
                          </h5>
                        </div>
                      </div>
                      <hr />
                      <Waypoint
                        fireOnRapidScroll="false"
                        key={subName}
                        topOffset="2"
                        bottomOffset="2"
                        onLeave={() => {
                          setSubCategory('all');
                        }}
                        onEnter={({
                          previousPosition,
                          currentPosition,
                          event
                        }) => {
                          setSubCategory(subName);
                        }}
                      >
                        <div className="row">
                          {liquor_products
                            .filter(
                              (product) => product.super_category === 'Beer'
                            )
                            .map((product) =>
                              product.sub_category === subName ? (
                                <div className="col-12 col-sm-6 col-lg-4 mb-5 p-0 ">
                                  <div className="conatiner-fluid m-2 display ml-4">
                                    <h5
                                      className="mb-4 mt-2 liquor-top-name"
                                      style={{
                                        color: '#000000',
                                        fontWeight: '600',
                                        fontSize: '110%',
                                        textTransform: 'capitalize'
                                      }}
                                    >
                                      {product.name}
                                    </h5>
                                    <div className="row liquor-top-name">
                                      {product.description.map((d, index) => (
                                        <div>
                                          {d === '' ? (
                                            <></>
                                          ) : (
                                            <div className="container-fluid mb-2 liquor-top-name">
                                              {product.price[index] <
                                              product.mrp[index] ? (
                                                <span
                                                  class="badge badge-success"
                                                  style={{
                                                    width: '20%',
                                                    position: 'absolute'
                                                  }}
                                                >
                                                  On Sale
                                                </span>
                                              ) : null}
                                              <div
                                                className="row"
                                                style={{
                                                  borderBottom:
                                                    '0.1px solid #00000010',
                                                  paddingTop: '6px',
                                                  boxShadow:
                                                    '-1px 1px 4px 2px #7f818e10'
                                                }}
                                              >
                                                <div className="col-4">
                                                  {product.image[index] ? (
                                                    <img
                                                      src={product.image[index]}
                                                      className="liquor-photo"
                                                      alt={subName}
                                                      style={{
                                                        width: '100%',
                                                        height: '100px'
                                                      }}
                                                    />
                                                  ) : (
                                                    <img
                                                      src="/img/defLiquor.jpg"
                                                      alt={subName}
                                                      className="liquor-photo"
                                                      style={{
                                                        width: '100%',
                                                        height: '100px'
                                                      }}
                                                    />
                                                  )}
                                                  {/* <h2><span className="badge badge-info mt-2">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-8">
                                                  <div className="container">
                                                    <div className="row">
                                                      <div className="col-12">
                                                        {/* <p style={{textAlign:'left',wordWrap:'break-word',overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis', marginBottom:'0'}}>
                                                  {this.props.product.sub_category}
                                                </p> */}
                                                        <p
                                                          style={{
                                                            textAlign: 'left',
                                                            wordWrap:
                                                              'break-word'
                                                          }}
                                                        >
                                                          {
                                                            product.description[
                                                              index
                                                            ]
                                                          }{' '}
                                                          Try, try again, You
                                                          can
                                                        </p>
                                                      </div>
                                                    </div>
                                                    <Divider />
                                                    <div
                                                      className="row mt-2"
                                                      style={{
                                                        marginLeft: 'auto'
                                                      }}
                                                    >
                                                      {+product.stock[index] >
                                                      0 ? (
                                                        <>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign:
                                                                'initial',
                                                              padding:
                                                                'inherit',
                                                              fontWeight: 'bold'
                                                            }}
                                                          >
                                                            $
                                                            {
                                                              product.price[
                                                                index
                                                              ]
                                                            }
                                                          </div>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign: 'right'
                                                            }}
                                                          >
                                                            <button
                                                              className="btn btnAdd"
                                                              style={{
                                                                padding:
                                                                  '0.2rem 0.75rem',
                                                                marginBottom:
                                                                  '5px'
                                                              }}
                                                              onClick={(
                                                                event
                                                              ) =>
                                                                handle(
                                                                  event,
                                                                  product,
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              {' '}
                                                              <i className="fa fa-plus">
                                                                &nbsp;Add
                                                              </i>
                                                            </button>
                                                          </div>
                                                        </>
                                                      ) : (
                                                        <>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign:
                                                                'initial',
                                                              padding:
                                                                'inherit',
                                                              fontWeight: 'bold'
                                                            }}
                                                            disabled
                                                          >
                                                            $
                                                            {
                                                              product.price[
                                                                index
                                                              ]
                                                            }
                                                          </div>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign: 'right'
                                                            }}
                                                          >
                                                            <button
                                                              className="btn btnAdd dis"
                                                              style={{
                                                                padding:
                                                                  '0.2rem 0.75rem',
                                                                marginBottom:
                                                                  '5px'
                                                              }}
                                                              disabled
                                                            >
                                                              {' '}
                                                              <i className="fa fa-plus">
                                                                &nbsp;Add
                                                              </i>
                                                            </button>
                                                          </div>
                                                        </>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              ) : null
                            )}
                        </div>
                      </Waypoint>
                    </div>
                  ) : (
                    ''
                  )
                )}
              </div>
            </div>{' '}
          </div>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <div className="container-fluid">
            <div className="row">
              <div
                className="col-lg-2 order-2 order-lg-1"
                style={{ marginTop: '-1em', paddingTop: '1em' }}
              >
                <div className="filter-widget">
                  <h5
                    style={{
                      textAlign: 'start',
                      color: '#000',
                      fontWeight: '400',
                      marginLeft: '12px'
                    }}
                  >
                    Sort by
                  </h5>
                  <div
                    className="col-12"
                    style={{
                      paddingTop: '0px',
                      marginTop: '-15px',
                      textAlign: 'start',
                      color: '#000'
                    }}
                  >
                    <i
                      className="fa fa-window-minimize"
                      id="line"
                      aria-hidden="true"
                    ></i>
                    <i className="fa fa-window-minimize" aria-hidden="true"></i>
                  </div>
                  <ul className="category-menu">
                    {liquor_subcategory.map((subCategory) =>
                      subCategory.includes('Cider') ? (
                        <li key={subCategory}>
                          <Link
                            style={
                              subCategory2 === subCategory
                                ? { background: '#36B89250' }
                                : { background: '#96B89210' }
                            }
                            onClick={() => {
                              goto(subCategory);
                              onPressCategory();
                              setSubCategory(subCategory);
                            }}
                            className={
                              subCategory2 === subCategory
                                ? 'category-menu-active'
                                : 'normal'
                            }
                          >
                            {subCategory.slice(0, subCategory.indexOf('('))}
                          </Link>
                        </li>
                      ) : (
                        ''
                      )
                    )}
                  </ul>
                </div>
              </div>
              <div
                className="col-lg-10  order-1 order-lg-2 mb-5 mb-lg-0"
                style={{ borderLeft: '1px solid lightgrey' }}
              >
                <div className="row">
                  <div
                    className="col-12"
                    style={{
                      textAlign: 'left',
                      paddingBottom: '0px',
                      marginBottom: '0px'
                    }}
                  >
                    <h5
                      style={{
                        paddingBottom: '0px',
                        marginBottom: '0px',
                        color: '#112c50',
                        fontWeight: '400'
                      }}
                    >
                      Products (
                      {
                        liquor_products
                          .filter(
                            (product) => product.super_category === 'Cider'
                          )
                          .map((product) => product).length
                      }
                      )
                    </h5>
                  </div>
                  <div
                    className="col-12"
                    style={{
                      paddingTop: '0px',
                      marginTop: '-12px',
                      textAlign: 'start',
                      color: '#000'
                    }}
                  >
                    <i
                      className="fa fa-window-minimize"
                      id="line"
                      aria-hidden="true"
                    ></i>
                    <i className="fa fa-window-minimize" aria-hidden="true"></i>
                  </div>
                </div>
                <br />
                <div className="row"></div>
                {liquor_subcategory.map((subName) =>
                  subName.includes('Cider') ? (
                    <div className="container-fluid" id={subName}>
                      <div className="row">
                        <div
                          className="col-12"
                          style={{ textAlign: 'initial' }}
                        >
                          <h5 style={{ fontWeight: 'bold', color: '#112c50' }}>
                            {subName.slice(0, subName.indexOf('('))}
                          </h5>
                        </div>
                      </div>
                      <hr />
                      <Waypoint
                        fireOnRapidScroll="false"
                        key={subName}
                        topOffset="2"
                        bottomOffset="2"
                        onLeave={() => {
                          setSubCategory('all');
                        }}
                        onEnter={({
                          previousPosition,
                          currentPosition,
                          event
                        }) => {
                          setSubCategory(subName);
                        }}
                      >
                        <div className="row">
                          {liquor_products
                            .filter(
                              (product) => product.super_category === 'Cider'
                            )
                            .map((product) =>
                              product.sub_category === subName ? (
                                <div className="col-12 col-sm-6 col-lg-4 mb-5 p-0">
                                  <div className="conatiner-fluid m-2 display ml-4">
                                    <h5
                                      className="mb-4 mt-2"
                                      style={{
                                        color: '#112c50',
                                        fontWeight: 'bold',
                                        fontSize: '150%',
                                        textTransform: 'capitalize'
                                      }}
                                    >
                                      {product.name}
                                    </h5>
                                    <div className="row">
                                      {product.description.map((d, index) => (
                                        <div>
                                          {d === '' ? (
                                            <></>
                                          ) : (
                                            <div className="container-fluid mb-2 liquor-top-name">
                                              {product.price[index] <
                                              product.mrp[index] ? (
                                                <span
                                                  class="badge badge-success"
                                                  style={{
                                                    width: '20%',
                                                    position: 'absolute'
                                                  }}
                                                >
                                                  On Sale
                                                </span>
                                              ) : null}
                                              <div
                                                className="row"
                                                style={{
                                                  borderBottom:
                                                    '0.1px solid #00000010',
                                                  paddingTop: '6px',
                                                  boxShadow:
                                                    '-1px 1px 4px 2px #7f818e10'
                                                }}
                                              >
                                                <div className="col-4">
                                                  {product.image[index] ? (
                                                    <img
                                                      src={product.image[index]}
                                                      className="liquor-photo"
                                                      alt={subName}
                                                      style={{
                                                        width: '100%',
                                                        height: '100px'
                                                      }}
                                                    />
                                                  ) : (
                                                    <img
                                                      src="/img/defLiquor.jpg"
                                                      alt={subName}
                                                      className="liquor-photo"
                                                      style={{
                                                        width: '100%',
                                                        height: '100px'
                                                      }}
                                                    />
                                                  )}
                                                </div>
                                                <div className="col-8">
                                                  <div className="container">
                                                    <div className="row">
                                                      <div className="col-12">
                                                        {/* <p style={{textAlign:'left',wordWrap:'break-word',overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis', marginBottom:'0'}}>
                              {this.props.product.sub_category}
                            </p> */}
                                                        <p
                                                          style={{
                                                            textAlign: 'left',
                                                            wordWrap:
                                                              'break-word'
                                                          }}
                                                        >
                                                          {
                                                            product.description[
                                                              index
                                                            ]
                                                          }{' '}
                                                          Try, try again, You
                                                          can
                                                        </p>
                                                      </div>
                                                    </div>
                                                    <Divider />
                                                    <div
                                                      className="row mt-2"
                                                      style={{
                                                        marginLeft: 'auto'
                                                      }}
                                                    >
                                                      {+product.stock[index] >
                                                      0 ? (
                                                        <>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign:
                                                                'initial',
                                                              padding:
                                                                'inherit',
                                                              fontWeight: 'bold'
                                                            }}
                                                          >
                                                            $
                                                            {
                                                              product.price[
                                                                index
                                                              ]
                                                            }
                                                          </div>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign: 'right'
                                                            }}
                                                          >
                                                            <button
                                                              className="btn btnAdd"
                                                              style={{
                                                                padding:
                                                                  '0.2rem 0.75rem',
                                                                marginBottom:
                                                                  '5px'
                                                              }}
                                                              onClick={(
                                                                event
                                                              ) =>
                                                                handle(
                                                                  event,
                                                                  product,
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              {' '}
                                                              <i className="fa fa-plus">
                                                                &nbsp;Add
                                                              </i>
                                                            </button>
                                                          </div>
                                                        </>
                                                      ) : (
                                                        <>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign:
                                                                'initial',
                                                              padding:
                                                                'inherit',
                                                              fontWeight: 'bold'
                                                            }}
                                                            disabled
                                                          >
                                                            $
                                                            {
                                                              product.price[
                                                                index
                                                              ]
                                                            }
                                                          </div>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign: 'right'
                                                            }}
                                                          >
                                                            <button
                                                              className="btn btnAdd dis"
                                                              style={{
                                                                padding:
                                                                  '0.2rem 0.75rem',
                                                                marginBottom:
                                                                  '5px'
                                                              }}
                                                              disabled
                                                            >
                                                              {' '}
                                                              <i className="fa fa-plus">
                                                                &nbsp;Add
                                                              </i>
                                                            </button>
                                                          </div>
                                                        </>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              ) : null
                            )}
                        </div>
                      </Waypoint>
                    </div>
                  ) : (
                    ''
                  )
                )}
              </div>
            </div>{' '}
          </div>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <div className="container-fluid">
            <div className="row">
              <div
                className="col-lg-2 order-2 order-lg-1"
                style={{ marginTop: '-1em', paddingTop: '1em' }}
              >
                <div className="filter-widget">
                  <h5
                    style={{
                      textAlign: 'start',
                      color: '#000',
                      fontWeight: '400',
                      marginLeft: '12px'
                    }}
                  >
                    Sort by
                  </h5>
                  <div
                    className="col-12"
                    style={{
                      paddingTop: '0px',
                      marginTop: '-15px',
                      textAlign: 'start',
                      color: '#000'
                    }}
                  >
                    <i
                      className="fa fa-window-minimize"
                      id="line"
                      aria-hidden="true"
                    ></i>
                    <i className="fa fa-window-minimize" aria-hidden="true"></i>
                  </div>
                  <ul className="category-menu">
                    {liquor_subcategory.map((subCategory) =>
                      subCategory.includes('WhiteWine') ? (
                        <li key={subCategory}>
                          <Link
                            style={
                              subCategory2 === subCategory
                                ? { background: '#36B89250' }
                                : { background: '#96B89210' }
                            }
                            onClick={() => {
                              goto(subCategory);
                              onPressCategory();
                              setSubCategory(subCategory);
                            }}
                            className={
                              subCategory2 === subCategory
                                ? 'category-menu-active'
                                : 'normal'
                            }
                          >
                            {subCategory.slice(0, subCategory.indexOf('('))}
                          </Link>
                        </li>
                      ) : (
                        ''
                      )
                    )}
                  </ul>
                </div>
              </div>
              <div
                className="col-lg-10  order-1 order-lg-2 mb-5 mb-lg-0"
                style={{ borderLeft: '1px solid lightgrey' }}
              >
                <div className="row">
                  <div className="col-12" style={{ textAlign: 'left' }}>
                    <h5
                      style={{
                        color: '#112c50',
                        paddingBottom: '0px',
                        marginBottom: '0px',
                        fontWeight: '400'
                      }}
                    >
                      Products (
                      {
                        liquor_products
                          .filter(
                            (product) => product.super_category === 'WhiteWine'
                          )
                          .map((product) => product).length
                      }
                      )
                    </h5>
                  </div>
                  <div
                    className="col-12"
                    style={{
                      paddingTop: '0px',
                      marginTop: '-12px',
                      textAlign: 'start',
                      color: '#000'
                    }}
                  >
                    <i
                      className="fa fa-window-minimize"
                      id="line"
                      aria-hidden="true"
                    ></i>
                    <i className="fa fa-window-minimize" aria-hidden="true"></i>
                  </div>
                </div>
                <br />
                <div className="row"></div>
                {liquor_subcategory.map((subName) =>
                  subName.includes('WhiteWine') ? (
                    <div className="container-fluid" id={subName}>
                      <div className="row">
                        <div
                          className="col-12"
                          style={{ textAlign: 'initial' }}
                        >
                          <h4 style={{ fontWeight: 'bold', color: '#112c50' }}>
                            {subName.slice(0, subName.indexOf('('))}
                          </h4>
                        </div>
                      </div>
                      <hr />
                      <Waypoint
                        fireOnRapidScroll="false"
                        key={subName}
                        topOffset="2"
                        bottomOffset="2"
                        onLeave={() => {
                          setSubCategory('all');
                        }}
                        onEnter={({
                          previousPosition,
                          currentPosition,
                          event
                        }) => {
                          setSubCategory(subName);
                        }}
                      >
                        <div className="row">
                          {liquor_products
                            .filter(
                              (product) =>
                                product.super_category === 'WhiteWine'
                            )
                            .map((product) =>
                              product.sub_category === subName ? (
                                <div className="col-12 col-sm-6 col-lg-4 mb-5 p-0">
                                  <div className="conatiner-fluid m-2 display ml-4">
                                    <h5
                                      className="mb-4 mt-2"
                                      style={{
                                        color: '#112c50',
                                        fontWeight: 'bold',
                                        fontSize: '150%',
                                        textTransform: 'capitalize'
                                      }}
                                    >
                                      {product.name}
                                    </h5>
                                    <div className="row">
                                      {product.description.map((d, index) => (
                                        <div>
                                          {d === '' ? (
                                            <></>
                                          ) : (
                                            <div className="container-fluid mb-2 liquor-top-name">
                                              {product.price[index] <
                                              product.mrp[index] ? (
                                                <span
                                                  class="badge badge-success"
                                                  style={{
                                                    width: '20%',
                                                    position: 'absolute'
                                                  }}
                                                >
                                                  On Sale
                                                </span>
                                              ) : null}
                                              <div
                                                className="row"
                                                style={{
                                                  borderBottom:
                                                    '0.1px solid #00000010',
                                                  paddingTop: '6px',
                                                  boxShadow:
                                                    '-1px 1px 4px 2px #7f818e10'
                                                }}
                                              >
                                                <div className="col-4">
                                                  {product.image[index] ? (
                                                    <img
                                                      src={product.image[index]}
                                                      className="liquor-photo"
                                                      alt={subName}
                                                      style={{
                                                        width: '100%',
                                                        height: '100px'
                                                      }}
                                                    />
                                                  ) : (
                                                    <img
                                                      src="/img/defLiquor.jpg"
                                                      alt={subName}
                                                      className="liquor-photo"
                                                      style={{
                                                        width: '100%',
                                                        height: '100px'
                                                      }}
                                                    />
                                                  )}
                                                  {/* <h2><span className="badge badge-info mt-2">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-8">
                                                  <div className="container">
                                                    <div className="row">
                                                      <div className="col-12">
                                                        {/* <p style={{textAlign:'left',wordWrap:'break-word',overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis', marginBottom:'0'}}>
                              {this.props.product.sub_category}
                            </p> */}
                                                        <p
                                                          style={{
                                                            textAlign: 'left',
                                                            wordWrap:
                                                              'break-word'
                                                          }}
                                                        >
                                                          {
                                                            product.description[
                                                              index
                                                            ]
                                                          }{' '}
                                                          Try, try again, You
                                                          can
                                                        </p>
                                                      </div>
                                                    </div>
                                                    <Divider />
                                                    <div
                                                      className="row mt-2"
                                                      style={{
                                                        marginLeft: 'auto'
                                                      }}
                                                    >
                                                      {+product.stock[index] >
                                                      0 ? (
                                                        <>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign:
                                                                'initial',
                                                              padding:
                                                                'inherit',
                                                              fontWeight: 'bold'
                                                            }}
                                                          >
                                                            $
                                                            {
                                                              product.price[
                                                                index
                                                              ]
                                                            }
                                                          </div>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign: 'right'
                                                            }}
                                                          >
                                                            <button
                                                              className="btn btnAdd"
                                                              style={{
                                                                padding:
                                                                  '0.2rem 0.75rem',
                                                                marginBottom:
                                                                  '5px'
                                                              }}
                                                              onClick={(
                                                                event
                                                              ) =>
                                                                handle(
                                                                  event,
                                                                  product,
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              {' '}
                                                              <i className="fa fa-plus">
                                                                &nbsp;Add
                                                              </i>
                                                            </button>
                                                          </div>
                                                        </>
                                                      ) : (
                                                        <>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign:
                                                                'initial',
                                                              padding:
                                                                'inherit',
                                                              fontWeight: 'bold'
                                                            }}
                                                            disabled
                                                          >
                                                            $
                                                            {
                                                              product.price[
                                                                index
                                                              ]
                                                            }
                                                          </div>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign: 'right'
                                                            }}
                                                          >
                                                            <button
                                                              className="btn btnAdd dis"
                                                              style={{
                                                                padding:
                                                                  '0.2rem 0.75rem',
                                                                marginBottom:
                                                                  '5px'
                                                              }}
                                                              disabled
                                                            >
                                                              {' '}
                                                              <i className="fa fa-plus">
                                                                &nbsp;Add
                                                              </i>
                                                            </button>
                                                          </div>
                                                        </>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              ) : null
                            )}
                        </div>
                      </Waypoint>
                    </div>
                  ) : (
                    ''
                  )
                )}
              </div>
            </div>{' '}
          </div>
        </TabPanel>

        <TabPanel value={value} index={3}>
          <div className="container-fluid">
            <div className="row">
              <div
                className="col-lg-2 order-2 order-lg-1"
                style={{ marginTop: '-1em', paddingTop: '1em' }}
              >
                <div className="filter-widget">
                  <h5
                    style={{
                      textAlign: 'start',
                      color: '#112c50',
                      fontWeight: '400',
                      marginLeft: '12px'
                    }}
                  >
                    Sort by
                  </h5>
                  <div
                    className="col-12"
                    style={{
                      paddingTop: '0px',
                      marginTop: '-15px',
                      textAlign: 'start',
                      color: '#000'
                    }}
                  >
                    <i
                      className="fa fa-window-minimize"
                      id="line"
                      aria-hidden="true"
                    ></i>
                    <i className="fa fa-window-minimize" aria-hidden="true"></i>
                  </div>
                  <ul className="category-menu">
                    {liquor_subcategory.map((subCategory) =>
                      subCategory.includes('RedWine') ? (
                        <li key={subCategory}>
                          <Link
                            style={
                              subCategory2 === subCategory
                                ? { background: '#36B89250' }
                                : { background: '#96B89210' }
                            }
                            onClick={() => {
                              goto(subCategory);
                              onPressCategory();
                              setSubCategory(subCategory);
                            }}
                            className={
                              subCategory2 === subCategory
                                ? 'category-menu-active'
                                : 'normal'
                            }
                          >
                            {subCategory.slice(0, subCategory.indexOf('('))}
                          </Link>
                        </li>
                      ) : (
                        ''
                      )
                    )}
                  </ul>
                </div>
              </div>
              <div
                className="col-lg-10  order-1 order-lg-2 mb-5 mb-lg-0"
                style={{ borderLeft: '1px solid lightgrey' }}
              >
                <div className="row">
                  <div className="col-12" style={{ textAlign: 'left' }}>
                    <h5
                      style={{
                        color: '#112c50',
                        paddingBottom: '0px',
                        marginBottom: '0px',
                        fontWeight: '400'
                      }}
                    >
                      Products (
                      {
                        liquor_products
                          .filter(
                            (product) => product.super_category === 'RedWine'
                          )
                          .map((product) => product).length
                      }
                      )
                    </h5>
                  </div>
                  <div
                    className="col-12"
                    style={{
                      paddingTop: '0px',
                      marginTop: '-12px',
                      textAlign: 'start',
                      color: '#000'
                    }}
                  >
                    <i
                      className="fa fa-window-minimize"
                      id="line"
                      aria-hidden="true"
                    ></i>
                    <i className="fa fa-window-minimize" aria-hidden="true"></i>
                  </div>
                </div>
                <br />
                <div className="row"></div>
                {liquor_subcategory.map((subName) =>
                  subName.includes('RedWine') ? (
                    <div className="container-fluid" id={subName}>
                      <div className="row">
                        <div
                          className="col-12"
                          style={{ textAlign: 'initial' }}
                        >
                          <h4 style={{ fontWeight: 'bold', color: '#112c50' }}>
                            {subName.slice(0, subName.indexOf('('))}
                          </h4>
                        </div>
                      </div>
                      <hr />
                      <Waypoint
                        fireOnRapidScroll="false"
                        key={subName}
                        topOffset="2"
                        bottomOffset="2"
                        onLeave={() => {
                          setSubCategory('all');
                        }}
                        onEnter={({
                          previousPosition,
                          currentPosition,
                          event
                        }) => {
                          setSubCategory(subName);
                        }}
                      >
                        <div className="row">
                          {liquor_products
                            .filter(
                              (product) => product.super_category === 'RedWine'
                            )
                            .map((product) =>
                              product.sub_category === subName ? (
                                <div className="col-12 col-sm-6 col-lg-4 mb-5 p-0">
                                  <div className="conatiner-fluid m-2 display ml-4">
                                    <h5
                                      className="mb-4 mt-2"
                                      style={{
                                        color: '#112c50',
                                        fontWeight: 'bold',
                                        fontSize: '150%',
                                        textTransform: 'capitalize'
                                      }}
                                    >
                                      {product.name}
                                    </h5>
                                    <div className="row">
                                      {product.description.map((d, index) => (
                                        <div>
                                          {d === '' ? (
                                            <></>
                                          ) : (
                                            <div className="container-fluid mb-2 liquor-top-name">
                                              {product.price[index] <
                                              product.mrp[index] ? (
                                                <span
                                                  class="badge badge-success"
                                                  style={{
                                                    width: '20%',
                                                    position: 'absolute'
                                                  }}
                                                >
                                                  On Sale
                                                </span>
                                              ) : null}
                                              <div
                                                className="row"
                                                style={{
                                                  borderBottom:
                                                    '0.1px solid #00000010',
                                                  paddingTop: '6px',
                                                  boxShadow:
                                                    '-1px 1px 4px 2px #7f818e10'
                                                }}
                                              >
                                                <div className="col-4">
                                                  {product.image[index] ? (
                                                    <img
                                                      src={product.image[index]}
                                                      className="liquor-photo"
                                                      alt={subName}
                                                      style={{
                                                        width: '100%',
                                                        height: '100px'
                                                      }}
                                                    />
                                                  ) : (
                                                    <img
                                                      src="/img/defLiquor.jpg"
                                                      alt={subName}
                                                      className="liquor-photo"
                                                      style={{
                                                        width: '100%',
                                                        height: '100px'
                                                      }}
                                                    />
                                                  )}
                                                  {/* <h2><span className="badge badge-info mt-2">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-8">
                                                  <div className="container">
                                                    <div className="row">
                                                      <div className="col-12">
                                                        {/* <p style={{textAlign:'left',wordWrap:'break-word',overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis', marginBottom:'0'}}>
                              {this.props.product.sub_category}
                            </p> */}
                                                        <p
                                                          style={{
                                                            textAlign: 'left',
                                                            wordWrap:
                                                              'break-word'
                                                          }}
                                                        >
                                                          {
                                                            product.description[
                                                              index
                                                            ]
                                                          }{' '}
                                                          Try, try again, You
                                                          can
                                                        </p>
                                                      </div>
                                                    </div>
                                                    <Divider />
                                                    <div
                                                      className="row mt-2"
                                                      style={{
                                                        marginLeft: 'auto'
                                                      }}
                                                    >
                                                      {+product.stock[index] >
                                                      0 ? (
                                                        <>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign:
                                                                'initial',
                                                              padding:
                                                                'inherit',
                                                              fontWeight: 'bold'
                                                            }}
                                                          >
                                                            $
                                                            {
                                                              product.price[
                                                                index
                                                              ]
                                                            }
                                                          </div>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign: 'right'
                                                            }}
                                                          >
                                                            <button
                                                              className="btn btnAdd"
                                                              style={{
                                                                padding:
                                                                  '0.2rem 0.75rem',
                                                                marginBottom:
                                                                  '5px'
                                                              }}
                                                              onClick={(
                                                                event
                                                              ) =>
                                                                handle(
                                                                  event,
                                                                  product,
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              {' '}
                                                              <i className="fa fa-plus">
                                                                &nbsp;Add
                                                              </i>
                                                            </button>
                                                          </div>
                                                        </>
                                                      ) : (
                                                        <>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign:
                                                                'initial',
                                                              padding:
                                                                'inherit',
                                                              fontWeight: 'bold'
                                                            }}
                                                            disabled
                                                          >
                                                            $
                                                            {
                                                              product.price[
                                                                index
                                                              ]
                                                            }
                                                          </div>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign: 'right'
                                                            }}
                                                          >
                                                            <button
                                                              className="btn btnAdd dis"
                                                              style={{
                                                                padding:
                                                                  '0.2rem 0.75rem',
                                                                marginBottom:
                                                                  '5px'
                                                              }}
                                                              disabled
                                                            >
                                                              {' '}
                                                              <i className="fa fa-plus">
                                                                &nbsp;Add
                                                              </i>
                                                            </button>
                                                          </div>
                                                        </>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              ) : null
                            )}
                        </div>
                      </Waypoint>
                    </div>
                  ) : (
                    ''
                  )
                )}
              </div>
            </div>{' '}
          </div>
        </TabPanel>
        <TabPanel value={value} index={4}>
          <div className="container-fluid">
            <div className="row">
              <div
                className="col-lg-2 order-2 order-lg-1"
                style={{ marginTop: '-1em', paddingTop: '1em' }}
              >
                <div className="filter-widget">
                  <h5
                    style={{
                      textAlign: 'start',
                      color: '#112c50',
                      fontWeight: '400',
                      marginLeft: '12px'
                    }}
                  >
                    Sort by
                  </h5>
                  <div
                    className="col-12"
                    style={{
                      paddingTop: '0px',
                      marginTop: '-15px',
                      textAlign: 'start',
                      color: '#000'
                    }}
                  >
                    <i
                      className="fa fa-window-minimize"
                      id="line"
                      aria-hidden="true"
                    ></i>
                    <i className="fa fa-window-minimize" aria-hidden="true"></i>
                  </div>
                  <ul className="category-menu">
                    {liquor_subcategory.map((subCategory) =>
                      subCategory.includes('Champagne') ? (
                        <li key={subCategory}>
                          <Link
                            style={
                              subCategory2 === subCategory
                                ? { background: '#36B89250' }
                                : { background: '#96B89210' }
                            }
                            onClick={() => {
                              goto(subCategory);
                              onPressCategory();
                              setSubCategory(subCategory);
                            }}
                            className={
                              subCategory2 === subCategory
                                ? 'category-menu-active'
                                : 'normal'
                            }
                          >
                            {subCategory.slice(0, subCategory.indexOf('('))}
                          </Link>
                        </li>
                      ) : (
                        ''
                      )
                    )}
                  </ul>
                </div>
              </div>
              <div
                className="col-lg-10  order-1 order-lg-2 mb-5 mb-lg-0"
                style={{ borderLeft: '1px solid lightgrey' }}
              >
                <div className="row">
                  <div className="col-12" style={{ textAlign: 'left' }}>
                    <h5
                      style={{
                        color: '#112c50',
                        paddingBottom: '0px',
                        marginBottom: '0px',
                        fontWeight: '400'
                      }}
                    >
                      Products (
                      {
                        liquor_products
                          .filter(
                            (product) => product.super_category === 'Champagne'
                          )
                          .map((product) => product).length
                      }
                      )
                    </h5>
                  </div>
                  <div
                    className="col-12"
                    style={{
                      paddingTop: '0px',
                      marginTop: '-12px',
                      textAlign: 'start',
                      color: '#000'
                    }}
                  >
                    <i
                      className="fa fa-window-minimize"
                      id="line"
                      aria-hidden="true"
                    ></i>
                    <i className="fa fa-window-minimize" aria-hidden="true"></i>
                  </div>
                </div>
                <br />
                <div className="row"></div>
                {liquor_subcategory.map((subName) =>
                  subName.includes('Champagne') ? (
                    <div className="container-fluid" id={subName}>
                      <div className="row">
                        <div
                          className="col-12"
                          style={{ textAlign: 'initial' }}
                        >
                          <h4 style={{ fontWeight: 'bold', color: '#112c50' }}>
                            {subName.slice(0, subName.indexOf('('))}
                          </h4>
                        </div>
                      </div>
                      <hr />
                      <Waypoint
                        fireOnRapidScroll="false"
                        key={subName}
                        topOffset="2"
                        bottomOffset="2"
                        onLeave={() => {
                          setSubCategory('all');
                        }}
                        onEnter={({
                          previousPosition,
                          currentPosition,
                          event
                        }) => {
                          setSubCategory(subName);
                        }}
                      >
                        <div className="row">
                          {liquor_products
                            .filter(
                              (product) =>
                                product.super_category === 'Champagne'
                            )
                            .map((product) =>
                              product.sub_category === subName ? (
                                <div className="col-12 col-sm-6 col-lg-4 mb-5 p-0">
                                  <div className="conatiner-fluid m-2 display ml-4">
                                    <h5
                                      className="mb-4 mt-2"
                                      style={{
                                        color: '#112c50',
                                        fontWeight: 'bold',
                                        fontSize: '150%',
                                        textTransform: 'capitalize'
                                      }}
                                    >
                                      {product.name}
                                    </h5>
                                    <div className="row">
                                      {product.description.map((d, index) => (
                                        <div>
                                          {d === '' ? (
                                            <></>
                                          ) : (
                                            <div className="container-fluid mb-2 liquor-top-name">
                                              {product.price[index] <
                                              product.mrp[index] ? (
                                                <span
                                                  class="badge badge-success"
                                                  style={{
                                                    width: '20%',
                                                    position: 'absolute'
                                                  }}
                                                >
                                                  On Sale
                                                </span>
                                              ) : null}
                                              <div
                                                className="row"
                                                style={{
                                                  borderBottom:
                                                    '0.1px solid #00000010',
                                                  paddingTop: '6px',
                                                  boxShadow:
                                                    '-1px 1px 4px 2px #7f818e10'
                                                }}
                                              >
                                                <div className="col-4">
                                                  {product.image[index] ? (
                                                    <img
                                                      src={product.image[index]}
                                                      className="liquor-photo"
                                                      alt={subName}
                                                      style={{
                                                        width: '100%',
                                                        height: '100px'
                                                      }}
                                                    />
                                                  ) : (
                                                    <img
                                                      src="/img/defLiquor.jpg"
                                                      alt={subName}
                                                      className="liquor-photo"
                                                      style={{
                                                        width: '100%',
                                                        height: '100px'
                                                      }}
                                                    />
                                                  )}
                                                  {/* <h2><span className="badge badge-info mt-2">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-8">
                                                  <div className="container">
                                                    <div className="row">
                                                      <div className="col-12">
                                                        {/* <p style={{textAlign:'left',wordWrap:'break-word',overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis', marginBottom:'0'}}>
                              {this.props.product.sub_category}
                            </p> */}
                                                        <p
                                                          style={{
                                                            textAlign: 'left',
                                                            wordWrap:
                                                              'break-word'
                                                          }}
                                                        >
                                                          {
                                                            product.description[
                                                              index
                                                            ]
                                                          }{' '}
                                                          Try, try again, You
                                                          can
                                                        </p>
                                                      </div>
                                                    </div>
                                                    <Divider />
                                                    <div
                                                      className="row mt-2"
                                                      style={{
                                                        marginLeft: 'auto'
                                                      }}
                                                    >
                                                      {+product.stock[index] >
                                                      0 ? (
                                                        <>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign:
                                                                'initial',
                                                              padding:
                                                                'inherit',
                                                              fontWeight: 'bold'
                                                            }}
                                                          >
                                                            $
                                                            {
                                                              product.price[
                                                                index
                                                              ]
                                                            }
                                                          </div>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign: 'right'
                                                            }}
                                                          >
                                                            <button
                                                              className="btn btnAdd"
                                                              style={{
                                                                padding:
                                                                  '0.2rem 0.75rem',
                                                                marginBottom:
                                                                  '5px'
                                                              }}
                                                              onClick={(
                                                                event
                                                              ) =>
                                                                handle(
                                                                  event,
                                                                  product,
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              {' '}
                                                              <i className="fa fa-plus">
                                                                &nbsp;Add
                                                              </i>
                                                            </button>
                                                          </div>
                                                        </>
                                                      ) : (
                                                        <>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign:
                                                                'initial',
                                                              padding:
                                                                'inherit',
                                                              fontWeight: 'bold'
                                                            }}
                                                            disabled
                                                          >
                                                            $
                                                            {
                                                              product.price[
                                                                index
                                                              ]
                                                            }
                                                          </div>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign: 'right'
                                                            }}
                                                          >
                                                            <button
                                                              className="btn btnAdd dis"
                                                              style={{
                                                                padding:
                                                                  '0.2rem 0.75rem',
                                                                marginBottom:
                                                                  '5px'
                                                              }}
                                                              disabled
                                                            >
                                                              {' '}
                                                              <i className="fa fa-plus">
                                                                &nbsp;Add
                                                              </i>
                                                            </button>
                                                          </div>
                                                        </>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              ) : null
                            )}
                        </div>
                      </Waypoint>
                    </div>
                  ) : (
                    ''
                  )
                )}
              </div>
            </div>{' '}
          </div>
        </TabPanel>
        <TabPanel value={value} index={5}>
          <div className="container-fluid">
            <div className="row">
              <div
                className="col-lg-2 order-2 order-lg-1"
                style={{ marginTop: '-1em', paddingTop: '1em' }}
              >
                <div className="filter-widget">
                  <h5
                    style={{
                      textAlign: 'start',
                      color: '#112c50',
                      fontWeight: '400',
                      marginLeft: '12px'
                    }}
                  >
                    Sort by
                  </h5>
                  <div
                    className="col-12"
                    style={{
                      paddingTop: '0px',
                      marginTop: '-15px',
                      textAlign: 'start',
                      color: '#000'
                    }}
                  >
                    <i
                      className="fa fa-window-minimize"
                      id="line"
                      aria-hidden="true"
                    ></i>
                    <i className="fa fa-window-minimize" aria-hidden="true"></i>
                  </div>

                  <ul className="category-menu">
                    {liquor_subcategory.map((subCategory) =>
                      subCategory.includes('Spirits') ? (
                        <li key={subCategory}>
                          <Link
                            style={
                              subCategory2 === subCategory
                                ? { background: '#36B89250' }
                                : { background: '#96B89210' }
                            }
                            onClick={() => {
                              goto(subCategory);
                              onPressCategory();
                              setSubCategory(subCategory);
                            }}
                            className={
                              subCategory2 === subCategory
                                ? 'category-menu-active'
                                : 'normal'
                            }
                          >
                            {subCategory.slice(0, subCategory.indexOf('('))}
                          </Link>
                        </li>
                      ) : (
                        ''
                      )
                    )}
                  </ul>
                </div>
              </div>
              <div
                className="col-lg-10  order-1 order-lg-2 mb-5 mb-lg-0"
                style={{ borderLeft: '1px solid lightgrey' }}
              >
                <div className="row">
                  <div className="col-12" style={{ textAlign: 'left' }}>
                    <h5
                      style={{
                        color: '#112c50',
                        paddingBottom: '0px',
                        marginBottom: '0px',
                        fontWeight: '400'
                      }}
                    >
                      Products (
                      {
                        liquor_products
                          .filter(
                            (product) => product.super_category === 'Spirits'
                          )
                          .map((product) => product).length
                      }
                      )
                    </h5>
                  </div>
                  <div
                    className="col-12"
                    style={{
                      paddingTop: '0px',
                      marginTop: '-12px',
                      textAlign: 'start',
                      color: '#000'
                    }}
                  >
                    <i
                      className="fa fa-window-minimize"
                      id="line"
                      aria-hidden="true"
                    ></i>
                    <i className="fa fa-window-minimize" aria-hidden="true"></i>
                  </div>
                </div>

                <br />
                <div className="row"></div>
                {liquor_subcategory.map((subName) =>
                  subName.includes('Spirits') ? (
                    <div className="container-fluid" id={subName}>
                      <div className="row">
                        <div
                          className="col-12"
                          style={{ textAlign: 'initial' }}
                        >
                          <h4 style={{ fontWeight: 'bold', color: '#112c50' }}>
                            {subName.slice(0, subName.indexOf('('))}
                          </h4>
                        </div>
                      </div>
                      <hr />
                      <Waypoint
                        fireOnRapidScroll="false"
                        key={subName}
                        topOffset="2"
                        bottomOffset="2"
                        onLeave={() => {
                          setSubCategory('all');
                        }}
                        onEnter={({
                          previousPosition,
                          currentPosition,
                          event
                        }) => {
                          setSubCategory(subName);
                        }}
                      >
                        <div className="row">
                          {liquor_products
                            .filter(
                              (product) => product.super_category === 'Spirits'
                            )
                            .map((product) =>
                              product.sub_category === subName ? (
                                <div className="col-12 col-sm-6 col-lg-4 mb-5 p-0">
                                  <div className="conatiner-fluid m-2 display ml-4">
                                    <h5
                                      className="mb-4 mt-2"
                                      style={{
                                        color: '#112c50',
                                        fontWeight: 'bold',
                                        fontSize: '150%',
                                        textTransform: 'capitalize'
                                      }}
                                    >
                                      {product.name}
                                    </h5>
                                    <div className="row">
                                      {product.description.map((d, index) => (
                                        <div>
                                          {d === '' ? (
                                            <></>
                                          ) : (
                                            <div className="container-fluid mb-2 liquor-top-name">
                                              {product.price[index] <
                                              product.mrp[index] ? (
                                                <span
                                                  class="badge badge-success"
                                                  style={{
                                                    width: '20%',
                                                    position: 'absolute'
                                                  }}
                                                >
                                                  On Sale
                                                </span>
                                              ) : null}
                                              <div
                                                className="row"
                                                style={{
                                                  borderBottom:
                                                    '0.1px solid #00000010',
                                                  paddingTop: '6px',
                                                  boxShadow:
                                                    '-1px 1px 4px 2px #7f818e10'
                                                }}
                                              >
                                                <div className="col-4">
                                                  {product.image[index] ? (
                                                    <img
                                                      src={product.image[index]}
                                                      className="liquor-photo"
                                                      alt={subName}
                                                      style={{
                                                        width: '100%',
                                                        height: '100px'
                                                      }}
                                                    />
                                                  ) : (
                                                    <img
                                                      src="/img/defLiquor.jpg"
                                                      alt={subName}
                                                      className="liquor-photo"
                                                      style={{
                                                        width: '100%',
                                                        height: '100px'
                                                      }}
                                                    />
                                                  )}
                                                  {/* <h2><span className="badge badge-info mt-2">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-8">
                                                  <div className="container">
                                                    <div className="row">
                                                      <div className="col-12">
                                                        {/* <p style={{textAlign:'left',wordWrap:'break-word',overflow:'hidden',whiteSpace:'nowrap',textOverflow:'ellipsis', marginBottom:'0'}}>
                              {this.props.product.sub_category}
                            </p> */}
                                                        <p
                                                          style={{
                                                            textAlign: 'left',
                                                            wordWrap:
                                                              'break-word'
                                                          }}
                                                        >
                                                          {
                                                            product.description[
                                                              index
                                                            ]
                                                          }{' '}
                                                          Try, try again, You
                                                          can
                                                        </p>
                                                      </div>
                                                    </div>
                                                    <Divider />
                                                    <div
                                                      className="row mt-2"
                                                      style={{
                                                        marginLeft: 'auto'
                                                      }}
                                                    >
                                                      {+product.stock[index] >
                                                      0 ? (
                                                        <>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign:
                                                                'initial',
                                                              padding:
                                                                'inherit',
                                                              fontWeight: 'bold'
                                                            }}
                                                          >
                                                            $
                                                            {
                                                              product.price[
                                                                index
                                                              ]
                                                            }
                                                          </div>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign: 'right'
                                                            }}
                                                          >
                                                            <button
                                                              className="btn btnAdd"
                                                              style={{
                                                                padding:
                                                                  '0.2rem 0.75rem',
                                                                marginBottom:
                                                                  '5px'
                                                              }}
                                                              onClick={(
                                                                event
                                                              ) =>
                                                                handle(
                                                                  event,
                                                                  product,
                                                                  index
                                                                )
                                                              }
                                                            >
                                                              {' '}
                                                              <i className="fa fa-plus">
                                                                &nbsp;Add
                                                              </i>
                                                            </button>
                                                          </div>
                                                        </>
                                                      ) : (
                                                        <>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign:
                                                                'initial',
                                                              padding:
                                                                'inherit',
                                                              fontWeight: 'bold'
                                                            }}
                                                            disabled
                                                          >
                                                            $
                                                            {
                                                              product.price[
                                                                index
                                                              ]
                                                            }
                                                          </div>
                                                          <div
                                                            className="col-6"
                                                            style={{
                                                              textAlign: 'right'
                                                            }}
                                                          >
                                                            <button
                                                              className="btn btnAdd dis"
                                                              style={{
                                                                padding:
                                                                  '0.2rem 0.75rem',
                                                                marginBottom:
                                                                  '5px'
                                                              }}
                                                              disabled
                                                            >
                                                              {' '}
                                                              <i className="fa fa-plus">
                                                                &nbsp;Add
                                                              </i>
                                                            </button>
                                                          </div>
                                                        </>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              ) : null
                            )}
                        </div>
                      </Waypoint>
                    </div>
                  ) : (
                    ''
                  )
                )}
              </div>
            </div>{' '}
          </div>
        </TabPanel>
        <TabPanel value={value} index={6}>
          <div className="container-fluid">
            <div className="row">
              <div
                className="col-lg-2 order-2 order-lg-1"
                style={{ marginTop: '-1em', paddingTop: '1em' }}
              >
                <div className="filter-widget">
                  <h5
                    style={{
                      textAlign: 'start',
                      color: '#112c50',
                      fontWeight: '400',
                      marginLeft: '12px'
                    }}
                  >
                    Sort by
                  </h5>
                  <div
                    className="col-12"
                    style={{
                      paddingTop: '0px',
                      marginTop: '-15px',
                      textAlign: 'start',
                      color: '#000'
                    }}
                  >
                    <i
                      className="fa fa-window-minimize"
                      id="line"
                      aria-hidden="true"
                    ></i>
                    <i className="fa fa-window-minimize" aria-hidden="true"></i>
                  </div>
                  <ul className="category-menu">
                    {liquor_subcategory.map((subCategory) =>
                      subCategory.includes('MixedDrinks') ? (
                        <li key={subCategory}>
                          <Link
                            style={
                              subCategory2 === subCategory
                                ? { background: '#36B89250' }
                                : { background: '#96B89210' }
                            }
                            onClick={() => {
                              goto(subCategory);
                              onPressCategory();
                              setSubCategory(subCategory);
                            }}
                            className={
                              subCategory2 === subCategory
                                ? 'category-menu-active'
                                : 'normal'
                            }
                          >
                            {subCategory.slice(0, subCategory.indexOf('('))}
                          </Link>
                        </li>
                      ) : (
                        ''
                      )
                    )}
                  </ul>
                </div>
              </div>
              <div
                className="col-lg-10  order-1 order-lg-2 mb-5 mb-lg-0"
                style={{ borderLeft: '1px solid lightgrey' }}
              >
                <div className="row">
                  <div className="col-12" style={{ textAlign: 'left' }}>
                    <h5
                      style={{
                        color: '#112c50',
                        paddingBottom: '0px',
                        marginBottom: '0px',
                        fontWeight: '400'
                      }}
                    >
                      Products (
                      {
                        liquor_products
                          .filter(
                            (product) =>
                              product.super_category === 'MixedDrinks'
                          )
                          .map((product) => product).length
                      }
                      )
                    </h5>
                  </div>
                  <div
                    className="col-12"
                    style={{
                      paddingTop: '0px',
                      marginTop: '-12px',
                      textAlign: 'start',
                      color: '#000'
                    }}
                  >
                    <i
                      className="fa fa-window-minimize"
                      id="line"
                      aria-hidden="true"
                    ></i>
                    <i className="fa fa-window-minimize" aria-hidden="true"></i>
                  </div>
                </div>
                <br />
                <div className="row"></div>
                {liquor_subcategory.map((subName) =>
                  subName.includes('MixedDrinks') ? (
                    <div className="container-fluid" id={subName}>
                      <div className="row">
                        <div
                          className="col-12"
                          style={{ textAlign: 'initial' }}
                        >
                          <h4 style={{ fontWeight: 'bold', color: '#112c50' }}>
                            {subName.slice(0, subName.indexOf('('))}
                          </h4>
                        </div>
                      </div>
                      <hr />
                      <Waypoint
                        fireOnRapidScroll="false"
                        key={subName}
                        topOffset="2"
                        bottomOffset="2"
                        onLeave={() => {
                          setSubCategory('all');
                        }}
                        onEnter={({
                          previousPosition,
                          currentPosition,
                          event
                        }) => {
                          setSubCategory(subName);
                        }}
                      >
                        <div className="row">
                          {liquor_products
                            .filter(
                              (product) =>
                                product.super_category === 'MixedDrinks'
                            )
                            .map((product) =>
                              product.sub_category === subName ? (
                                <div className="col-12 col-sm-6 col-lg-4 mb-5 p-0">
                                  <div className="conatiner-fluid m-2 display ml-4">
                                    <h5
                                      className="mb-4 mt-2"
                                      style={{
                                        color: '#112c50',
                                        fontWeight: 'bold',
                                        fontSize: '150%',
                                        textTransform: 'capitalize'
                                      }}
                                    >
                                      {product.name}
                                    </h5>
                                    <div className="row">
                                      {product.description.map((d, index) => (
                                        <div>
                                          {d === '' ? (
                                            <></>
                                          ) : (
                                            <div className="container-fluid">
                                              {' '}
                                              <div
                                                className="row"
                                                style={{
                                                  borderBottom:
                                                    '0.1px solid #A8E4D590',
                                                  paddingTop: '6px',
                                                  boxShadow:
                                                    '-1px 1px 4px 2px #7f818e10'
                                                }}
                                              >
                                                <div className="col-4 liquor-img">
                                                  <img
                                                    src={product.image[index]}
                                                    className="liquor-photo"
                                                    alt=""
                                                    style={{
                                                      width: '100px',
                                                      height: '100px'
                                                    }}
                                                  />
                                                  {/* <h2><span className="badge badge-info mt-5">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-4">
                                                  <p
                                                    style={{
                                                      fontSize: '110%',
                                                      wordBreak: 'break-word',
                                                      color: '#b3afaf'
                                                    }}
                                                  >
                                                    {product.description[index]}
                                                  </p>
                                                  {/* <h2><span className="badge badge-info mt-5 ">$34.99</span></h2> */}
                                                </div>
                                                <div className="col-4">
                                                  {+product.stock[index] > 0 ? (
                                                    <button
                                                      className="btn btnAdd"
                                                      style={{
                                                        color: '#00000099'
                                                      }}
                                                      onClick={(event) =>
                                                        handle(
                                                          event,
                                                          product,
                                                          index
                                                        )
                                                      }
                                                    >
                                                      {' '}
                                                      <i className="fa fa-plus"></i>{' '}
                                                      Add
                                                    </button>
                                                  ) : (
                                                    <button
                                                      className="btn btnAdd"
                                                      style={{
                                                        color: '#00000099'
                                                      }}
                                                    >
                                                      {' '}
                                                      Out of stock
                                                    </button>
                                                  )}
                                                  <h4>
                                                    <span
                                                      className="badge badge-info mt-4 shadow-lg"
                                                      style={{
                                                        color: '#00000099',
                                                        paddingLeft: '12px',
                                                        paddingRight: '12px',
                                                        paddingTop: '8px',
                                                        paddingBottom: '8px',
                                                        borderRadius: '40px',
                                                        background: '#F8F8F8',
                                                        border:
                                                          '0.8px solid #00000020',
                                                        textAlign: 'center',
                                                        fontWeight: '400',
                                                        fontSize: '16px',
                                                        lineHeight: '16px'
                                                      }}
                                                    >
                                                      ${product.price[index]}
                                                    </span>
                                                  </h4>
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                </div>
                              ) : null
                            )}
                        </div>
                      </Waypoint>
                    </div>
                  ) : (
                    ''
                  )
                )}
              </div>
            </div>{' '}
          </div>
        </TabPanel>
      </div>
      <div className="container-fluid">
        <div className="row ">
          <div
            className="myBanner"
            style={{ textAlign: 'initial', marginBottom: '-1px' }}
          >
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <h4 className="text-white">
                    Get anything from anywhere, at anytime
                  </h4>
                </div>
                <div className="col-12">
                  <p className="text-white">
                    Life is too short to waste it in finding the product you
                    need from thousands of products in your Favorite
                    supermarket, just click the photo of the product you need
                    and get it to deliver with Grospick.
                  </p>
                </div>
                <div className="col-12">
                  <p className="text-white">
                    Our trained shoppers will shop for you in the grocery store
                    and deliver to your home at the exact same price as the
                    stores. Want to eat at your favorite restaurant, but they
                    don't deliver? We will pick up your food and deliver it in
                    minutes. This is a new way of life. The very best in your
                    city, delivered in minutes.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div
            className="container"
            style={{
              color: '#fff',
              background: '#fff',
              height: '1px',
              width: '92%'
            }}
          ></div>
        </div>
        <div className="row">
          <div
            className="myBanner"
            style={{
              backgroundImage:
                'url(../../../../../img/footer.png), linear-gradient( 0deg, rgb(19, 25, 41) 0%, rgb(29, 36, 60) 100%)',
              backgroundPosition: 'bottom right'
            }}
          >
            <div className="container">
              <div className="row">
                <div className="col-1 col-md-1 mt-5">
                  <img src="../../../../../img/logo.png" alt="" />
                </div>
                <div className="col-2 col-md-2 footer-categorie">
                  {!auth ? (
                    <>
                      <h5
                        className="text-white footer-font"
                        style={{ paddingBottom: '3px', fontWeight: '700' }}
                      >
                        CUSTOMERS
                      </h5>
                      <Link
                        to="/vendor/login"
                        style={{ textDecoration: 'none' }}
                      >
                        <p
                          className="text-white footer-paragraph"
                          style={{
                            color: '#fff',
                            fontSize: '15px',
                            paddingBottom: '0px',
                            paddingTop: '2px',
                            marginBottom: '4px',
                            fontWeight: 400
                          }}
                        >
                          Vendor Login
                        </p>
                      </Link>
                    </>
                  ) : (
                    ''
                  )}
                  {!auth ? (
                    <Link to="/admin/login" style={{ textDecoration: 'none' }}>
                      <p
                        className="text-white footer-paragraph"
                        style={{
                          color: '#fff',
                          fontSize: '15px',
                          paddingBottom: '0px',
                          marginBottom: '2px',
                          fontWeight: 400
                        }}
                      >
                        Admin Login
                      </p>
                    </Link>
                  ) : (
                    ''
                  )}
                  <Link to="" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Community service
                    </p>
                  </Link>
                </div>
                <div className="col-3 col-md-2" style={{ textAlign: 'left' }}>
                  <h5
                    className="text-white footer-font"
                    style={{ paddingBottom: '3px', fontWeight: '700' }}
                  >
                    GROSPICK
                  </h5>
                  <Link to="./about" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        paddingTop: '2px',
                        marginBottom: '4px',
                        fontWeight: 400
                      }}
                    >
                      About
                    </p>
                  </Link>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Jobs
                    </p>
                  </Link>
                  <Link to="./contact" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Contact Us
                    </p>
                  </Link>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Terms & Conditions
                    </p>
                  </Link>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        fontWeight: 400
                      }}
                    >
                      Privacy Policy
                    </p>
                  </Link>
                </div>
                <div className="col-3 col-md-2" style={{ textAlign: 'left' }}>
                  <h5
                    className="text-white footer-font"
                    style={{ paddingBottom: '3px', fontWeight: '700' }}
                  >
                    GET IN TOUCH
                  </h5>
                  <Link to="./contact" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        paddingTop: '2px',
                        marginBottom: '4px',
                        fontWeight: 400
                      }}
                    >
                      Email
                    </p>
                  </Link>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://twitter.com/grospick"
                    style={{ textDecoration: 'none' }}
                  >
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Twitter
                    </p>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.facebook.com/Grospick-108163027510472/"
                    style={{ textDecoration: 'none' }}
                  >
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Facebook
                    </p>
                  </a>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.instagram.com/grospicker/?hl=en"
                    style={{ textDecoration: 'none' }}
                  >
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      Instagram
                    </p>
                  </a>
                  <a
                    target="_blank"
                    href="#endregion"
                    style={{ textDecoration: 'none' }}
                  >
                    <p
                      className="text-white footer-paragraph"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        fontWeight: 400
                      }}
                    >
                      LinkedIn
                    </p>
                  </a>
                </div>
                <div
                  className="col-3 col-md-2 footer-categorie2"
                  style={{
                    textAlign: 'left',
                    paddingRight: '0px',
                    paddingLeft: '0px'
                  }}
                >
                  <h5
                    className="text-white footer-font"
                    style={{ paddingBottom: '3px', fontWeight: '700' }}
                  >
                    GET OUR APP
                  </h5>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        paddingTop: '2px',
                        marginBottom: '4px',
                        fontWeight: 400
                      }}
                    >
                      <i
                        className="fa fa-android"
                        style={{ paddingRight: '3px' }}
                      ></i>{' '}
                      Android
                    </p>
                  </Link>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      <i
                        className="fa fa-apple"
                        style={{ paddingRight: '3px' }}
                      ></i>{' '}
                      Ios
                    </p>
                  </Link>
                  <Link to="#" style={{ textDecoration: 'none' }}>
                    <p
                      className="text-white"
                      style={{
                        color: '#fff',
                        fontSize: '15px',
                        paddingBottom: '0px',
                        marginBottom: '2px',
                        fontWeight: 400
                      }}
                    >
                      <i
                        className="fa fa-desktop"
                        style={{ paddingRight: '4px' }}
                      ></i>{' '}
                      Desktop
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const mapDispatchToProps = (dispatch) => ({
  getAllProducts: (category, uid) => dispatch(getAllProducts(category, uid)),
  getSubCategory: (category, uid) => dispatch(getSubCategory(category, uid)),
  getVendorDetails: (uid) => dispatch(getVendorDetails(uid))
});
const mapStateWithProps = (state) => ({
  vendors: state.user.vendors,
  products: state.user,
  vendor: state.shared.vendor,
  auth: state.user.auth,
  loader: state.ui.user_loading,
  store_loader: state.ui.store_loader
});
export default connect(mapStateWithProps, mapDispatchToProps)(NavTabs);
